
import PIXI from '../GameEngine/pixi.js';
export default class ButtonSmallInfo extends PIXI.Container {
    constructor(text, color, width, style, ...arg) {
        super(...arg);
        this._text = text;
        this.color = color || 0x479ACE;// or 0x479ACE or 0xC03500;
        this.width1 = width || 160;
        this.style = style;
        if (!this.style) {
            this.style = new PIXI.TextStyle({
                fontFamily: 'Arial',
                fontSize: 14 * 2,
                fill: '#FFFFFF',
                align: 'center'
            });
        }


        let styleSmallInfo = new PIXI.TextStyle({
            fontFamily: "\"Times New Roman\", Times, serif",
            fontSize: 12 * 2,
            fill: this.color,
            fontWeight: "bold"
        });

        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(this.color);
        graphics.lineStyle(0, 0xFFFFFF, 1);
        // graphics.drawRect(0, 0, 250, 60);
        graphics.drawRoundedRect(0, 0, this.width1, 40, 10);
        //graphics.alpha = 0.9;
        this.addChild(graphics);



        //this.width = 400;
        //this.height = 50;
        //this.anchor.set(0.5);


        this.textMessage = new PIXI.Text(this._text, this.style);
        this.textMessage.x = this.width / 2;
        this.textMessage.y = 12;
        this.textMessage.scale.set(0.5);
        this.textMessage.anchor.set(0.5, 0);
        this.addChild(this.textMessage);


        let offsetXY = -2;
        let circleSize = 5;
        //background
        var circleInfoIcon = new PIXI.Graphics();
        circleInfoIcon.beginFill(0xFFFFFF);
        //circleInfoIcon.lineStyle(1, 0xFFFFFF, 1);
        circleInfoIcon.drawCircle(this.width1 - circleSize + offsetXY, circleSize - offsetXY, circleSize);
        circleInfoIcon.endFill();
        this.addChild(circleInfoIcon);


        this.textInfoIcon = new PIXI.Text("i", styleSmallInfo);
        this.textInfoIcon.x = this.width1 - circleSize + offsetXY;
        this.textInfoIcon.y = 0 +1;
        this.textInfoIcon.scale.set(0.5);
        this.textInfoIcon.anchor.set(0.5, 0);
        this.addChild(this.textInfoIcon);
    }
    get text() {
        return this_.text;
    }
    set text(value) {
        this._text = value;
        if (this.textMessage) this.textMessage.text = value;
    }
}